import React, { useState, useEffect, useMemo, useRef } from "react";
import Layout from "../../components/layout/Layout";
import AddIcon from "@mui/icons-material/Add";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  IconButton,
  InputLabel,
  ListItemText,
  Menu,
  MenuItem,
  OutlinedInput,
  Pagination,
  Select,
  Skeleton,
} from "@mui/material";
import GetAppIcon from '@mui/icons-material/GetApp';
import FundReceivedDrawer from "./FundReceivedDrawer";
import SearchIcon from "@mui/icons-material/SearchOutlined";
import { useSnackbar } from "notistack";
import CloseIcon from "@mui/icons-material/Close";
import {
  RECORD_DISPLAY_LIMIT,
} from "../../utils/constants/constants";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import FeeGenerated from "./FeeGenerated";
import ActiveScheme from "./ActiveScheme";
import PaymentHistory from "./PaymentHistory";
import {
  apiFunds,
  getPartners,
} from "../../utils/api/api";
import { SNACKBAR_ERROR } from "../../utils/constants/constants";
import { isSubAdmin, toLocalePriceNoDecimal } from "../../utils/StringUtil";
import ReceiptIcon from "@mui/icons-material/Receipt";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import MoveToInboxIcon from "@mui/icons-material/MoveToInbox";
import ChecklistIcon from "@mui/icons-material/Checklist";
import FundWithdraw from "./FundWithdraw";
import PartnerPayments from "./PartnerPayments";
import InvestorFeeGenerated from "./InvestorFeeGenerated";
import SchemeExpenses from "./SchemeExpenses";
import SchemeIncome from "./SchemeIncome";
import { TableHeadButton } from "../../components/ui/TableHeadButton";
import { apiFundMasterDownload } from "../../utils/api/api";

function FundMaster() {
  const [open, setOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [anchorElMap, setAnchorElMap] = useState({});
  const [anchorElMain, setAnchorElMain] = useState(null);
  const openMainMenu = Boolean(anchorElMain);
  const [openFundWithdraw, setOpenFundWithdraw] = useState(false);
  const [openFeeGenerated, setOpenFeeGenerated] = useState(false);
  const [openInvFeeGenerated, setOpenInvFeeGenerated] = useState(false);
  const [openActiveScheme, setOpenActiveScheme] = useState(false);
  const [openPaymentHistory, setOpenPaymentHistory] = useState(false);
  const [openPartnerPayments, setOpenPartnerPayments] = useState(false);
  const [openSchemeExpenses, setOpenSchemeExpenses] = useState(false);
  const [openSchemeIncome, setOpenSchemeIncome] = useState(false);

  const [investorList, setInvestorList] = useState([]);
  const [editInvestor, setEditInvestor] = useState(null);
  const [fundTotalObj, setFundTotalObj] = useState(null);

  const [totalRecords, setTotalRecords] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [sort, setSort] = useState("");
  const [order, setOrder] = useState("");

  const [filterPartner, setFilterPartner] = useState([]);
  const [partnerList, setPartnerList] = useState([]);
  const getPartnersCalledRef = useRef(false);
  const prevParamsRef = useRef(null);
  const initialLoadRef = useRef(false);

  const userType = process.env.REACT_APP_USER_TYPE;

  const handleMenuOpen = (event, index) => {
    setAnchorElMap((prevState) => ({
      ...prevState,
      [index]: event.currentTarget,
    }));
  };
  const handleMenuClose = (index) => {
    setAnchorElMap((prevState) => ({
      ...prevState,
      [index]: null,
    }));
  };

  const handleOpen = () => {
    setOpen(true);
    setEditInvestor(null);
  };

  const handleClose = () => {
    setOpen(false);
    setIsEdit(false);
  };

  const handleSave = () => {
    setPage(1);
    getFunds({},true);
    handleClose();
  };

  const handleFundWithdrawSave = () => {
    setPage(1);
    getFunds({},true);
    toggleFundWithdraw();
  };

  const handleActiveSchemeSave = () => {
    setPage(1);
    getFunds();
    toggleActiveScheme();
  };

  const handlePaymentHistorySave = () => {
    setPage(1);
    getFunds();
    // togglePaymentHistory();
  };

  const handleEdit = (index, id) => {
    setEditInvestor(investorList.find((item) => item.invRid === id));
    setOpen(true);
    setIsEdit(true);
    handleMenuClose(index);
  };

  const handlePageChange = (_event, value) => {
    setPage(value);
  };

  const togglePartnerPayments = () => {
    if (openPartnerPayments) {
      setOpenPartnerPayments(false);
    } else {
      setOpenPartnerPayments(true);
      setAnchorElMain(null);
    }
  };

  const toggleSchemeExpenses = () => {
    if (openSchemeExpenses) {
      setOpenSchemeExpenses(false);
    } else {
      setOpenSchemeExpenses(true);
      setAnchorElMain(null);
    }
  }

  const toggleSchemeIncome = () => {
    if (openSchemeIncome) {
      setOpenSchemeIncome(false);
    } else {
      setOpenSchemeIncome(true);
      setAnchorElMain(null);
    }
  }

  const toggleFundWithdraw = (index, id) => {
    setEditInvestor(investorList.find((item) => item.invRid === id));
    setOpenFundWithdraw(!openFundWithdraw);
    handleMenuClose(index);
  };

  const toggleFeeGenerated = (index, id) => {
    if (openFeeGenerated) {
      setOpenFeeGenerated(false);
    } else {
      setOpenFeeGenerated(true);
      setAnchorElMain(null);
    }
  };

  const toggleInvFeeGenerated = (index, id) => {
    if (openInvFeeGenerated) {
      setOpenInvFeeGenerated(false);
    } else {
      setEditInvestor(investorList.find((item) => item.invRid === id));
      setOpenInvFeeGenerated(true);
      handleMenuClose(index);
    }
  };

  const toggleActiveScheme = (index, id) => {
    setEditInvestor(investorList.find((item) => item.invRid === id));
    setOpenActiveScheme(!openActiveScheme);
    handleMenuClose(index);
  };

  const togglePaymentHistory = (index, id) => {
    setEditInvestor(investorList.find((item) => item.invRid === id));
    setOpenPaymentHistory(!openPaymentHistory);
    handleMenuClose(index);
  };

  // const getFunds = (param = {}) => {
  //   setIsLoading(true);
  //   const apiParams = {
  //     name: searchTerm,
  //     recLimit: RECORD_DISPLAY_LIMIT,
  //     pageNumber: page,
  //     partnerRid: filterPartner.map((item) => item).join(","),
  //     sort: sort,
  //     order: order,
  //     ...param
  //   };
  //   const paramsString = JSON.stringify(apiParams);
  //   if (prevParamsRef.current === paramsString) {
  //     setIsLoading(false);
  //     return;
  //   }
  //   prevParamsRef.current = paramsString;
  //   apiFunds(apiParams)
  //     .then((data) => {
  //       setIsLoading(false);
  //       setInvestorList(data.funds);
  //       if (apiParams.pageNumber === 1) {
  //         setTotalRecords(data.records);
  //         setFundTotalObj(data.fundsTotal);
  //       }
  //     })
  //     .catch((error) => {
  //       setIsLoading(false);
  //       enqueueSnackbar(error, SNACKBAR_ERROR);
  //     });
  // };
  const getFunds = (param = {}, forceRefresh = false) => {
    setIsLoading(true);
    const apiParams = {
      name: searchTerm,
      recLimit: RECORD_DISPLAY_LIMIT,
      pageNumber: page,
      partnerRid: filterPartner.map((item) => item).join(","),
      sort: sort,
      order: order,
      ...param
    };
    const paramsString = JSON.stringify(apiParams);
    
    // Skip optimization check if force refresh is enabled
    if (!forceRefresh && prevParamsRef.current === paramsString) {
      setIsLoading(false);
      return; 
    }
    
    prevParamsRef.current = paramsString;
    apiFunds(apiParams)
      .then((data) => {
        setIsLoading(false);
        setInvestorList(data.funds);
        if (apiParams.pageNumber === 1) {
          setTotalRecords(data.records);
          setFundTotalObj(data.fundsTotal);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        enqueueSnackbar(error, SNACKBAR_ERROR);
      });
  };
  
  useEffect(() => {
    if (initialLoadRef.current) {
      if (searchTerm.length < 3) {
        if (searchTerm.trim() === "") {
          getFunds();
        }
      } else {
        getFunds();
      }
      setPage(1);
    }
  }, [searchTerm]);

  useEffect(() => {
    if (initialLoadRef.current) {
      getFunds();
    }
  }, [page]);

  useEffect(() => {
    if (initialLoadRef.current) {
      getFunds();
      setPage(1);
    }
  }, [filterPartner]);


  const getPartnersList = () => {
    setPartnerList([]);
    getPartners()
      .then((res) => {
        setPartnerList(res.partnerMasterList);
      })
      .catch((e) => {
        enqueueSnackbar(e, SNACKBAR_ERROR);
      });
  };

  useEffect(() => {
    if (!getPartnersCalledRef.current) {
      getPartnersList();
      getPartnersCalledRef.current = true;
    }
  }, []);
  useEffect(() => {
    if (!initialLoadRef.current) {
      initialLoadRef.current = true;
      getFunds();
    }
  }, []);

  const handleSort = (key) => {
    let direction = 'ascending';
    if (sort === key && order === 'asc') {
      direction = 'descending';
    } else if (sort === key && order === 'descending') {
      direction = 'ascending';
    } else {
      direction = 'ascending';
    }
  };

  useEffect(() => {
    if (initialLoadRef.current && sort !== "" && order !== "") {
      getFunds();
    }
  }, [sort, order]);

  const downloadFile = async (response) => {
    const blob = new Blob([response.data], { type: response.headers.get('content-type') });
    const downloadLink = document.createElement('a');
    const url = window.URL.createObjectURL(blob);
    downloadLink.href = url;
    downloadLink.setAttribute('download', response.headers.get('content-disposition').split('"')[1]);
    downloadLink.click();
    window.URL.revokeObjectURL(url);
  }

  const downloadFundMasterList = (param = {}) => {
    param.name = searchTerm;
    param.partnerRid = filterPartner.map((item) => item).join(",");
    param.sort = sort;
    param.order = order;

    apiFundMasterDownload(param)
    .then((data) => {
        downloadFile(data);
    })
    .catch((error) => {
        enqueueSnackbar(error,SNACKBAR_ERROR);
    });
  }

  return (
    <Layout title="Fund Master">
      {userType === "ADMIN" && !isSubAdmin() && (
        <Button
          sx={{
            height: "64px",
            borderRadius: "50%",
            position: "fixed",
            bottom: "20px",
            right: "20px",
          }}
          onClick={handleOpen}
          variant="contained"
          aria-label="edit"
          color="secondary"
        >
          <AddIcon />
        </Button>
      )}

      <FundReceivedDrawer
        open={open}
        onClose={handleClose}
        isEdit={isEdit}
        investor={editInvestor}
        handleSave={() => handleSave()}
      />
      <FundWithdraw
        open={openFundWithdraw}
        toggleDrawer={toggleFundWithdraw}
        investor={editInvestor}
        handleSave={() => handleFundWithdrawSave()}
      />
      <InvestorFeeGenerated
        open={openInvFeeGenerated}
        toggleDrawer={toggleInvFeeGenerated}
        investor={editInvestor}
      />
      <FeeGenerated
        open={openFeeGenerated}
        toggleDrawer={toggleFeeGenerated}
        fundTotalObj={fundTotalObj}
      />
      <ActiveScheme
        open={openActiveScheme}
        toggleDrawer={toggleActiveScheme}
        investor={editInvestor}
        handleSave={() => handleActiveSchemeSave()}
      />
      <PaymentHistory
        open={openPaymentHistory}
        toggleDrawer={togglePaymentHistory}
        investor={editInvestor}
        handleSave={() => handlePaymentHistorySave()}
      />
      <PartnerPayments
        open={openPartnerPayments}
        toggleDrawer={togglePartnerPayments}
      />
      <SchemeExpenses
        open={openSchemeExpenses}
        toggleDrawer={toggleSchemeExpenses}
      />
      <SchemeIncome
        open={openSchemeIncome}
        toggleDrawer={toggleSchemeIncome}
      />

      <div className="p-4">
        <div
          className="d-flex flex-row justify-content-between bg-white p-3 mb-4"
          style={{ borderRadius: "5px" }}
        >
          <div className="d-flex gap-2 align-items-center">
            <div
              className="search-input-btn d-flex flex-row justify-content-between rounded bg-white px-3"
              style={{ border: "1px solid #000" }}
            >
              <div className="my-auto">
                <SearchIcon />
              </div>
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="form-control custom-form-control border-0 bg-transparent fs-large-regular "
                placeholder="Search"
              />
              <div onClick={() => setSearchTerm("")} className="my-auto">
                <CloseIcon sx={{ cursor: "pointer" }} />
              </div>
            </div>
            {userType === "ADMIN" && (
              <>
                <FormControl sx={{ width: 180 }} size="small">
                  <InputLabel id="demo-multiple-checkbox-label">
                    Filter By Partner
                  </InputLabel>
                  <Select
                    multiple
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    value={filterPartner}
                    onChange={(e) => setFilterPartner(e.target.value)}
                    input={<OutlinedInput label="Filter By Partner" />}
                    renderValue={(selected) => `${selected.length} Selected`}
                  >
                    {partnerList.map((data, key) => (
                      <MenuItem key={key} value={data.partnerRid}>
                        <Checkbox
                          checked={filterPartner.indexOf(data.partnerRid) > -1}
                        />
                        <ListItemText primary={data.fullName} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {/*commented sorting Investor by name  13/01/2025*/}

                {/* <Tooltip title="Sort">
              <IconButton
                color="secondary"
                aria-controls={openSortMenu ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={openSortMenu ? "true" : undefined}
                onClick={(e) => setAnchorElSort(e.currentTarget)}
              >
                <FilterListIcon />
              </IconButton>
            </Tooltip>
                <Menu
                  sx={{ boxSizing: "small" }}
                  id="basic-menu"
                  anchorEl={anchorElSort}
                  open={openSortMenu}
                  onClose={() => setAnchorElSort(null)}
                  MenuListProps={{ "aria-labelledby": "basic-button" }}
                  PaperProps={{ style: { width: "250px" } }}
                >
                  <p className="fs-normal-semibold text-primary px-3 my-2">
                    Investor Name
                  </p>
                  <RadioGroup
                    value={sortFund}
                    onChange={(e) => handleFund(parseInt(e.target.value))}
                  >
                    <MenuItem className="d-flex justify-content-between align-items-center">
                      <p className="fs-normal-medium p-0 m-0">Sort By ASC</p>
                      <Radio size="24px" value="1" />
                    </MenuItem>
                    <MenuItem className="d-flex justify-content-between align-items-center">
                      <p className="fs-normal-medium p-0 m-0">Sort By DESC</p>
                      <Radio size="24px" value="2" />
                    </MenuItem>
                  </RadioGroup>
                  <Divider />
                  <MenuItem onClick={() => handleFund(null)}>
                    <p className="fs-normal-medium p-0 m-0">Clear</p>
                  </MenuItem>
                </Menu> */}
              </>
            )}
            {userType === "ADMIN" && !isSubAdmin() && (
              <Button
                sx={{ textTransform: 'none' }}

                onClick={(e) => downloadFundMasterList()}
                startIcon={<GetAppIcon />}
              >
                <span className="fs-med-regular">Export to Excel</span>
              </Button>)}
          </div>


          <div className="d-flex gap-2 align-items-center">
            <Pagination
              color="secondary"
              size="small"
              siblingCount={0}
              onChange={handlePageChange}
              count={
                totalRecords < RECORD_DISPLAY_LIMIT
                  ? 1
                  : Math.ceil(totalRecords / RECORD_DISPLAY_LIMIT)
              }
              page={page}
            />
            {/* <Button sx={{width: 200}} variant="contained" className="ms-3" color="secondary" onClick={toggleFeeGenerated} disableElevation>Fee Generated</Button> */}
            {userType === 'ADMIN' &&
              <IconButton
                color="secondary"
                id="basic-button"
                aria-controls={openMainMenu ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={openMainMenu ? "true" : undefined}
                onClick={(e) => setAnchorElMain(e.currentTarget)}
              >
                <MoreVertIcon fontSize="medium" />
              </IconButton>
            }
            <Menu
              id="basic-menu"
              anchorEl={anchorElMain}
              open={openMainMenu}
              elevation={3}
              onClose={() => setAnchorElMain(null)}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              <MenuItem
                className="fs-large-regular"
                onClick={toggleFeeGenerated}
              >
                Fee Generated
              </MenuItem>
              <MenuItem
                className="fs-large-regular"
                onClick={togglePartnerPayments}
              >
                Partner Payments
              </MenuItem>
              {!isSubAdmin() && userType === 'ADMIN' ?
                <MenuItem
                  className="fs-large-regular"
                  onClick={toggleSchemeExpenses}
                >
                  Scheme Expenses
                </MenuItem> : null
              }
              <MenuItem
                className="fs-large-regular"
                onClick={toggleSchemeIncome}
              >
                Scheme Income
              </MenuItem>

            </Menu>
          </div>
        </div>

        <div
          className="d-flex gap-4 justify-content-between align-items-center bg-white p-3 mb-4"
          style={{ borderRadius: "5px" }}
        >
          <Box>
            <p className="section-label mb-1" style={{ fontSize: "12px" }}>
              commitments
            </p>
            <p className="fs-med-medium p-0 m-0">
              ₹ {toLocalePriceNoDecimal(fundTotalObj?.mcaAmount)}
            </p>
          </Box>
          <Box>
            <p className="section-label mb-1" style={{ fontSize: "12px" }}>
              Yet to Transfer
            </p>
            <p className="fs-med-medium p-0 m-0">
              ₹ {toLocalePriceNoDecimal(fundTotalObj?.yetToTransfer)}
            </p>
          </Box>
          <Box>
            <p className="section-label mb-1" style={{ fontSize: "12px" }}>
              Unallocated
            </p>
            <p className="fs-med-medium p-0 m-0">
              ₹ {toLocalePriceNoDecimal(fundTotalObj?.unAllocated)}
            </p>
          </Box>
          <Box>
            <p className="section-label mb-1" style={{ fontSize: "12px" }}>
              Undeployed
            </p>
            <p className="fs-med-medium p-0 m-0">
              ₹ {toLocalePriceNoDecimal(fundTotalObj?.unDeployed)}
            </p>
          </Box>
          <Box>
            <p className="section-label mb-1" style={{ fontSize: "12px" }}>
              Deployed
            </p>
            <p className="fs-med-medium p-0 m-0">
              ₹ {toLocalePriceNoDecimal(fundTotalObj?.deployed)}
            </p>
          </Box>
        </div>

        <div className="bg-white py-2 px-3" style={{ borderRadius: "5px" }}>
          {isLoading ? (
            [...Array(RECORD_DISPLAY_LIMIT)].map((_e, index) => (
              <Skeleton
                animation="wave"
                key={index}
                style={{ marginBottom: 6 }}
                variant="rectangle"
                height={40}
              />
            ))
          ) : (
            <div>
              <table
                className="table table-striped table-borderless w-100"
                id="order-table"
              >
                <thead>
                  <tr className="fs-normal-semibold text-center">
                    <th scope="col">
                      <TableHeadButton
                        label="Investor"
                        activeUp={order === "asc" && sort === "full_name"}
                        activeDown={order === "desc" && sort === "full_name"}
                        onClick={() => {
                          const nextOrder = sort === "full_name" ? (order === "asc" ? "desc" : "asc") : "asc";
                          setSort("full_name");
                          setOrder(nextOrder);
                          handleSort('full_name'); // Ensure it updates the sortConfig too
                        }}
                      />
                    </th>
                    <th scope="col">
                      <TableHeadButton
                        label="Commitment Amount"
                        activeUp={order === "asc" && sort === "mca_amount"}
                        activeDown={order === "desc" && sort === 'mca_amount'}
                        onClick={() => {
                          const nextOrder = sort === "mca_amount" ? (order === "asc" ? "desc" : "asc") : "asc";
                          setSort("mca_amount");
                          setOrder(nextOrder);
                          handleSort('mcaAmount'); // Ensure it updates the sortConfig too
                        }}
                        leftAlign
                      />
                    </th>
                    <th scope="col">
                      <TableHeadButton
                        label="Yet to Transfer"
                        activeUp={order === "asc" && sort === 'yetToTransfer'}
                        activeDown={order === "desc" && sort === 'yetToTransfer'}
                        onClick={() => {
                          const nextOrder = sort === "yetToTransfer" ? (order === "asc" ? "desc" : "asc") : "asc";
                          setSort("yetToTransfer");
                          setOrder(nextOrder);
                          handleSort('yetToTransfer'); // Ensure it updates the sortConfig too
                        }}
                        leftAlign
                      />
                    </th>
                    <th scope="col">
                      <TableHeadButton
                        label="Unallocated"
                        activeUp={order === "asc" && sort === 'unAllocated'}
                        activeDown={order === "desc" && sort === 'unAllocated'}
                        onClick={() => {
                          const nextOrder = sort === "unAllocated" ? (order === "asc" ? "desc" : "asc") : "asc";
                          setSort("unAllocated");
                          setOrder(nextOrder);
                          handleSort('mcaAmount'); // Ensure it updates the sortConfig too
                        }}
                        leftAlign
                      />
                    </th>
                    <th scope="col">
                      <TableHeadButton
                        label="Undeployed"
                        activeUp={order === "asc" && sort === 'unDeployed'}
                        activeDown={order === "desc" && sort === 'unDeployed'}
                        onClick={() => {
                          const nextOrder = sort === "unDeployed" ? (order === "asc" ? "desc" : "asc") : "asc";
                          setSort("unDeployed");
                          setOrder(nextOrder);
                          handleSort('unDeployed'); // Ensure it updates the sortConfig too
                        }}
                        leftAlign
                      />
                    </th>
                    <th scope="col">
                      <TableHeadButton
                        label="Deployed"
                        activeUp={order === "asc" && sort === 'deployed'}
                        activeDown={order === "desc" && sort === 'deployed'}
                        onClick={() => {
                          const nextOrder = sort === "deployed" ? (order === "asc" ? "desc" : "asc") : "asc";
                          setSort("deployed");
                          setOrder(nextOrder);
                          handleSort('deployed');
                        }}
                        leftAlign
                      />
                    </th>
                    <th scope="col">
                      <p className="mb-1">Actions</p>
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-table-blue">
                  {investorList.map((data, key) => {
                    return (
                      <tr className="fs-normal-medium text-center" key={key}>
                        <td className="pt-3">
                          {data.fullName}
                          <span className="fs-small-regular text-muted ms-2">
                            {data.invCode}
                          </span>
                        </td>
                        <td className="pt-3 text-end">
                          {toLocalePriceNoDecimal(data.mcaAmount)}
                        </td>
                        <td className="pt-3 text-end">
                          {toLocalePriceNoDecimal(data.yetToTransfer)}
                        </td>
                        <td className="pt-3 text-end">
                          {toLocalePriceNoDecimal(data.unAllocated)}
                        </td>
                        <td className="pt-3 text-end">
                          {toLocalePriceNoDecimal(data.unDeployed)}
                        </td>
                        <td className="pt-3 text-end">
                          {toLocalePriceNoDecimal(data.deployed)}
                        </td>
                        <td className="pt-0 text-center">
                          <IconButton
                            id="basic-button"
                            aria-controls={
                              Boolean(anchorElMap[key])
                                ? "basic-menu"
                                : undefined
                            }
                            aria-haspopup="true"
                            aria-expanded={
                              Boolean(anchorElMap[key]) ? "true" : undefined
                            }
                            onClick={(e) => handleMenuOpen(e, key)}
                          >
                            <MoreVertIcon fontSize="small" />
                          </IconButton>
                          <Menu
                            id="basic-menu"
                            anchorEl={anchorElMap[key]}
                            open={Boolean(anchorElMap[key])}
                            elevation={1}
                            onClose={() => handleMenuClose(key)}
                            MenuListProps={{
                              "aria-labelledby": "basic-button",
                            }}
                            color="secondary"
                          >
                            {!isSubAdmin() && (
                              <MenuItem
                                className="fs-med-regular"
                                onClick={() => handleEdit(key, data.invRid)}
                              >
                                <MoveToInboxIcon
                                  className="me-2"
                                  fontSize="small"
                                />
                                Fund Received
                              </MenuItem>
                            )}
                            {userType === "ADMIN" && !isSubAdmin() && (
                              <MenuItem
                                className="fs-med-regular"
                                onClick={() =>
                                  toggleFundWithdraw(key, data.invRid)
                                }
                              >
                                <MoveToInboxIcon
                                  className="me-2"
                                  fontSize="small"
                                />
                                Fund Withdraw
                              </MenuItem>
                            )}
                            {userType === "ADMIN" && (
                              <MenuItem
                                className="fs-med-regular"
                                onClick={() =>
                                  togglePaymentHistory(key, data.invRid)
                                }
                              >
                                <ReceiptIcon
                                  className="me-2"
                                  fontSize="small"
                                />
                                Payment History
                              </MenuItem>
                            )}

                            <MenuItem
                              className="fs-med-regular"
                              onClick={() =>
                                toggleInvFeeGenerated(key, data.invRid)
                              }
                            >
                              <ReceiptLongIcon
                                className="me-2"
                                fontSize="small"
                              />
                              Fee Generated
                            </MenuItem>
                            <MenuItem
                              className="fs-med-regular"
                              onClick={() =>
                                toggleActiveScheme(key, data.invRid)
                              }
                            >
                              <ChecklistIcon
                                className="me-2"
                                fontSize="small"
                              />
                              Active Schemes
                            </MenuItem>
                          </Menu>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
}

export default FundMaster;
